import React from "react";

const PhoneIcon: React.FC<{ className?: string; color?: string }> = ({
  className,
  color = "#545454", // Default color is #545454
}) => (
  <svg
    className={className}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6578 8.47962L9.03273 7.3546C8.92059 7.30681 8.79596 7.29674 8.67761 7.32591C8.55925 7.35508 8.45357 7.4219 8.37647 7.51633L7.21395 8.93666C5.38949 8.07645 3.92121 6.60817 3.06099 4.7837L4.48133 3.62118C4.57594 3.54423 4.64291 3.43855 4.67209 3.32013C4.70127 3.20172 4.69107 3.07702 4.64305 2.96492L3.51803 0.339872C3.46532 0.219028 3.3721 0.120363 3.25444 0.0608898C3.13677 0.00141686 3.00205 -0.0151363 2.87349 0.0140846L0.435945 0.576595C0.311998 0.605217 0.201412 0.675005 0.122237 0.774571C0.0430613 0.874136 -2.85523e-05 0.997599 1.41945e-08 1.12481C1.41945e-08 7.13663 4.87274 12 10.8752 12C11.0024 12.0001 11.126 11.957 11.2256 11.8778C11.3252 11.7987 11.395 11.688 11.4236 11.5641L11.9861 9.12651C12.0152 8.99733 11.9983 8.86206 11.9383 8.74399C11.8784 8.62593 11.7792 8.53244 11.6578 8.47962Z"
      fill={color}
    />
  </svg>
);

export default PhoneIcon;
